import { render, staticRenderFns } from "./tax.list.view.vue?vue&type=template&id=337345f4&scoped=true"
import script from "./tax.list.view.vue?vue&type=script&lang=js"
export * from "./tax.list.view.vue?vue&type=script&lang=js"
import style0 from "./tax.list.view.vue?vue&type=style&index=0&id=337345f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337345f4",
  null
  
)

export default component.exports